import React, { Component } from 'react'
import moment from 'moment'

import { secondsToTimeString } from 'utils'

export default class HeaderTimerCounter extends Component {
	updateInterval = null

	UNSAFE_componentWillMount = _ => {
		const {
			session
		} = this.props

		this.updateInterval = setInterval(_ => {
			if(session.isActive){
				this.forceUpdate()
			}
		},1000)
	}

	componentWillUnmount = _ => {
		clearInterval(this.updateInterval)
	}

	render() {
		const {
			session
		} = this.props

		let secondsAgo = session.savedSeconds

		// lastActive may be incorrect cause we add time when you edit times.
		// lastUpdated MAY also cause issues if you edit a session while it's running? Minor, though.
		if(session.isActive){
			const secondsInThisSession = moment().diff(session.lastUpdated, 'seconds')

			secondsAgo += secondsInThisSession
		}

		const formattedDuration = secondsToTimeString(secondsAgo)

		return (
			<span className="timer-counter">
				{ formattedDuration }
			</span>
		)
	}
}
